"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryNodeParamData = exports.listOptionsData = void 0;
/*
 * @Author: your name
 * @Date: 2024-09-11 15:57:04
 * @LastEditTime: 2024-09-11 16:24:27
 * @LastEditors: LAPTOP-8AGF652M
 * @Description: In User Settings Edit
 * @FilePath: \cmes-project-web\src\components\SimpleFlow\src\components\NodeContent.js
 */
var queryNodeParamData = exports.queryNodeParamData = {
  sortOrder: "desc",
  sortColumn: "createTime",
  conditionLink: "AND",
  pageNum: 1,
  pageSize: 2,
  staticConditions: [],
  conditions: [{
    column: "stationDeployId",
    exp: "=",
    value: "1830780023501426689"
  }, {
    column: "collect_time",
    exp: ">=",
    value: "2024-09-06 09:26:35"
  }, {
    column: "collect_time",
    exp: "<=",
    value: "2024-09-10 14:24:43"
  }]
};
var listOptionsData = exports.listOptionsData = {
  dataSource: {
    url: '/trace/stack-route/getFlowItemData',
    method: 'POST'
  }
};